import type { UnitOrigin } from "@/lib/org-structure-tree";

/**
 * Cores de procedência e de cadastro das unidades organizacionais — uma fonte
 * só para lista, card e legenda. As duas de procedência são as duas cores
 * primárias do myGROW (amarelo `#ffc83d` e azul-escuro `#08254c`); o verde é
 * o mesmo tom claro dos selos de sucesso. Classes escritas por extenso porque
 * o Tailwind só gera o que encontra literal no código.
 *
 * - `stripe`: faixa lateral da linha da lista;
 * - `glow`: sombra do card — a borda do card fica no cinza neutro, porque a
 *   borda colorida em toda a grade pesava demais;
 * - `swatch`: amostra da legenda.
 */
export const ORG_UNIT_ACCENT: {
  sap: { stripe: string; glow: string; swatch: string };
  manual: { stripe: string; glow: string; swatch: string };
  registered: string;
  registeredSwatch: string;
} = {
  sap: {
    stripe: "border-l-[#ffc83d]",
    glow: "shadow-[0_2px_12px_rgba(255,200,61,0.45)] hover:shadow-[0_4px_18px_rgba(255,200,61,0.6)]",
    swatch: "bg-[#ffc83d]",
  },
  manual: {
    stripe: "border-l-[#08254c]",
    glow: "shadow-[0_2px_12px_rgba(8,37,76,0.28)] hover:shadow-[0_4px_18px_rgba(8,37,76,0.4)]",
    swatch: "bg-[#08254c]",
  },
  registered: "bg-[#effaf3]",
  registeredSwatch: "border border-[#cfe8d8] bg-[#effaf3]",
};

export function originAccent(origin: UnitOrigin) {
  return ORG_UNIT_ACCENT[origin] ?? ORG_UNIT_ACCENT.sap;
}
